import { render, staticRenderFns } from "./toBeRectified.vue?vue&type=template&id=21e63329&scoped=true"
import script from "./toBeRectified.vue?vue&type=script&lang=js"
export * from "./toBeRectified.vue?vue&type=script&lang=js"
import style0 from "./toBeRectified.vue?vue&type=style&index=0&id=21e63329&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e63329",
  null
  
)

export default component.exports